import { useEffect, useState } from 'react';
import Header from '../componets/Layout/Header';
import Sidebar from '../componets/Layout/Sidebar';
import Pagination from '../componets/Pagination';
import UserTable from '../componets/user/UserTable';
import { getUserList } from '../controller';
import { requestHandler } from '../helper';

function User() {
  const [userData, setUserData] = useState([]);
  let perPage = 10;
  const [page, setPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [status, setStatus] = useState("");
  const [isPremium, setIsPremium] = useState("");
  const [plan, setPlan] = useState("");


  const getAllUsers = async () => {
    await requestHandler(
      async () => await getUserList(page, perPage, searchQuery, status, isPremium, plan),
      null,
      (res) => {
        setUserData(res.data.users);
        setPage(res.data.page);
        setPaginationValue(res.data.paginationValue);
      },
      () => { }
    );
  }


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getAllUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, page, status, isPremium, plan, perPage]); // 

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1); // Reset to the first page when search changes
  };

  const handleStatusChange = (newValue) => {
    setStatus(newValue);
    setPage(1);
  }

  const handlePlanChange = (newValue) => {
    setPlan(newValue);
    setPage(1);
  }

  const handleIsPremiumChange = (newValue) => {
    setIsPremium(newValue);
    setPage(1);
  }

  return (
    <>
      <div className='layouy-main'>
        <div className='sidebar-hide-show'>
          <Sidebar />
        </div>
        <div className='w-100'>
          <Header />
          <div className="tebs-title">
            <p className='active'>User Management</p>
          </div>
          <section>
            <div className="card main-card">
              <div className="card-body px-0 pt-0">
                <div className="table-main">
                  <div className="card">
                    <div className="card-body">
                      <div className='tables-container'>
                        <div>
                          <UserTable userData={userData} searchQuery={searchQuery} handleSearchChange={handleSearchChange} onStatusChange={handleStatusChange} perPage={perPage} page={page} getAllUsers={getAllUsers} setPage={setPage} onPremiumChange={handleIsPremiumChange} isPremium={isPremium} onPlanChange={handlePlanChange} plan={plan} status={status} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='d-flex justify-content-center mt-4'>
                    {paginationValue > 1 && (
                      <Pagination
                        currentPage={page}
                        totalPages={paginationValue}
                        onPageChange={(newPage) => {
                          setPage(newPage);
                        }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default User